module.exports = __webpack_public_path__ + "img/building_shigongxijie.9a0e9c24.png";